module.exports = __webpack_public_path__ + "static/assets/8447a900a52e87d717ddeda4280434c1.png";